import { Box } from '@mui/system';
import { NodeTypes } from '@utils/flows';
import React, { useCallback, useMemo, useState } from 'react';
import { Edge, Node, useViewport } from 'reactflow';
import { IEdgeData, IFlowScreens, ITaskNodeData } from 'types/flows';
import { useEventListener } from 'usehooks-ts';
import ActionableNode from '../ActionableNode';
import EndNode from '../EndNode';
import StartNode from '../StartNode';

const readyNode = (node: Node) => {
	switch (node.type) {
		case NodeTypes.startNode:
			return StartNode;
		case NodeTypes.endNode:
			return EndNode;
		default:
			return ActionableNode;
	}
};

const AddTaskPreview = ({
	state
}: {
	state: {
		nodes: Node<ITaskNodeData>[];
		edges: Edge<IEdgeData>[];
		screens?: IFlowScreens;
		initialPosition: { x: number; y: number };
	} | null;
}) => {
	const [currentPosition, setCurrentPosition] = useState<{
		x: number;
		y: number;
	}>(state?.initialPosition || { x: 0, y: 0 });
	const { zoom } = useViewport();
	const onWindowMouseMove = useCallback(
		(e: MouseEvent) => {
			setCurrentPosition({ x: e.clientX, y: e.clientY });
		},
		[setCurrentPosition]
	);

	useEventListener('mousemove', onWindowMouseMove);

	const offset = useMemo(
		() =>
			// offset from bottom left to the middle of the grab position by node type
			state?.nodes?.[0].type === NodeTypes.actionNode ? 150 : 30,
		[state?.nodes]
	);

	if (!state) return null;

	const { nodes } = state;

	return (
		<Box
			data-testid="add-task-preview-container"
			sx={{
				position: 'fixed',
				background: 'red',
				top: currentPosition.y - 1,
				left: currentPosition.x - offset * zoom, // middle
				zIndex: 2000,
				cursor: 'grabbing',
				transform: `scale(${zoom})`
			}}
		>
			{nodes.map((node, i) => {
				const ReadyNode = readyNode(node);
				return (
					<Box
						sx={{
							position: 'absolute',
							top: node.position.y,
							left: node.position.x
						}}
						key={node.id}
					>
						<ReadyNode
							xPos={0}
							yPos={0}
							{...node}
							data={{ ...node.data, interactions: [] }}
							zIndex={1000}
							type=""
							id={`new-${i}`}
							selected={false}
							isConnectable={false}
							dragging
						/>
					</Box>
				);
			})}
		</Box>
	);
};

export default AddTaskPreview;
